import axios from 'axios'
import _ from 'lodash'

// state
const state = {
	showSessionExpired: false,   // show session expired message
	showCancelRequestConfirm: false,	// show confirm message for cancelling a request
	showCancelRequestNotSaved: false,	// show message when notes have been added but not submitted
	showCancelRequestSuccess: false,  // show message request has been cancelled
	showRequestReceived: false,  // show message request has been received
	showRequestNotSaved: false,  // show request not saved
	showRequestCancelled: false,  // show request cancelled
	showLocationExisted: false,  // show message location existed
	showInterpreterSecured: false,  // show message when interpreter has been secured
	showInterpreterNotAvailable: false,  // show message when interpreter is no longer available
	showInterpreterReplaced: false,  // show message when interpreter has been replaced
	showLastMinuteCancel: false,  // show message when cancelling last minute
	showTimeConflict: false,  // show message for time conflict
	showRequestMax: false,  // show message for max request
	showRequiredFieldMessage: false,  // show required field message
	showUploadMessage: false,  // show profile upload message
	showProfileNotSaved: false,  // show profile message
	showAccountNotSaved: false,  // show account message
	showAccountSaved: false,  // show account saved message

	showDeleteFileConfirm: false,  // show delete file confirmation
	showDeleteFileSuccess: false,  // show delete file success
	showUploadFileSuccess: false,  // show upload file success
	showDeleteVosConfirm: false,		// show delete vos confirmation
	showDeleteVosSuccess: false,		// show delete vos success

	viewUploadedVosModal: false,
	viewDigitalVosModal: false,
	
	viewUploadedFiles: false, 					// show uploaded files

	viewComplianceFilesModal: false,
	viewVendorComplianceDetailsModal: false,
	showDeleteVendorComplianceDetailConfirm: false,
	showDeleteVendorComplianceDetailSuccess: false,
	viewDocHubInstructionModal: false,
	viewCompleteOnlineFormModal: false,
}

const getters = {

}


// mutations
const mutations = {
	TOGGLE_BOOLEAN_STATE(state, {key, bool}){
		eval('state.' + key + ' = bool');
	},
	SET_VARIABLE(state, {key, value}){
		eval('state.' + key + ' = value');
	},
}

// actions
const actions = {
	setShowMessage({commit}, {key, bool}){
		commit('TOGGLE_BOOLEAN_STATE', {key: key, bool: bool});
	},
	setVariable({commit}, {key, value}){
		commit('SET_VARIABLE', {key: key, value: value})
	}
}

export default {
    namespaced: true,
	state,
	getters,
	mutations,
	actions
}